import { render } from "./ApeConstructorCategories.vue?vue&type=template&id=6efa535b"
import script from "./ApeConstructorCategories.vue?vue&type=script&lang=js"
export * from "./ApeConstructorCategories.vue?vue&type=script&lang=js"

import "./ApeConstructorCategories.vue?vue&type=style&index=0&id=6efa535b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__